<script setup lang="ts">
import useUserStore from "~/stores/user";

const route = useRoute();
const userStore = useUserStore();
const appConfig = useRuntimeConfig().public;

const componentKey = ref(0);
const withSearch = computed(() => !(route.path.startsWith("/search") || route.path.startsWith("/archive")));
const hasNotifications = appConfig.APP_FLAGS.hasNotifications;
const isLoggedIn = computed(() => userStore.isAuthenticated);
</script>

<template>
  <div class="min-h-screen flex flex-col bg-[var(--base-background-color)]">
    <PageContainer class="w-full">
      <div class="pt-6 space-y-2">
        <div class="flex items-center justify-between">
          <AppLogo />

          <div class="flex items-center gap-6 justify-center">
            <AppSearchIcon v-if="withSearch" />
            <template v-if="isLoggedIn">
              <AppNotificationsIcon v-if="hasNotifications" />
              <AppUserIcon />
            </template>
            <AppAuthButtons v-else class="-ml-6" @login-success="componentKey++" />
          </div>
        </div>
        <AppHeaderLinks />
      </div>
    </PageContainer>

    <main :key="componentKey" class="flex-1">
      <slot />
    </main>

    <AppFooter />
  </div>
</template>
